import React from 'react';
import ReactDOM from 'react-dom';

const LearnMore = ({
	title,
	learnMoreDescription,
	tags,
	isVisible,
	onClose,
}) => {
	if (!isVisible) return null;

	const paragraphs = Array.isArray(learnMoreDescription)
		? learnMoreDescription
		: [learnMoreDescription];

	return ReactDOM.createPortal(
		<div className="learn-more-backdrop" onClick={onClose}>
			<div className="learn-more-overlay" onClick={(e) => e.stopPropagation()}>
				<button className="learn-more-close" onClick={onClose}>
					✕
				</button>
				<h2 className="learn-more-title">{title}</h2>
				{tags?.length > 0 && (
					<div className="learn-more-tags">
						{tags.map((tag, i) => (
							<span key={i} className="learn-more-tag">
								{tag}
							</span>
						))}
					</div>
				)}
				<div className="learn-more-description">
					{paragraphs.map((p, i) => (
						<p key={i}>{p}</p>
					))}
				</div>
			</div>
		</div>,
		document.body,
	);
};

export default LearnMore;
